module.exports = __webpack_public_path__ + "static/media/mon-site.be5e8f99.svg";